import { win } from "../../../common/namespaces";
import { NAV_SCOPES } from "../lib/utils";
import type { NavigationScope, NavigationScopeName, NavigationScopeOptions } from "./scope.types";
import type { KeyFilter } from "../lib/utils";

/**
 *
 */
export type AnyNavigationScope = NavigationScope<NavigationScopeName, NavigationScopeOptions>;

declare global {
  interface Window {
    /*                                    */
    [NAV_SCOPES]: {
      scopeCache: Map<string, AnyNavigationScope>;
      scopesFiltered: Map<string, Set<AnyNavigationScope>>;
      hashFiltered: Map<KeyFilter, Set<AnyNavigationScope>>;
      searchFiltered: Map<KeyFilter, Set<AnyNavigationScope>>;
      pathFiltered: Map<RegExp, Set<AnyNavigationScope>>;
    };
  }
}

/*                                                                    */
win[NAV_SCOPES] ??= {
  scopeCache: new Map(),
  scopesFiltered: new Map(),
  hashFiltered: new Map(),
  searchFiltered: new Map(),
  pathFiltered: new Map<RegExp, Set<AnyNavigationScope>>(),
};

/**
 *
 *
 *
 */
export const scopeCache = win[NAV_SCOPES].scopeCache;

/**
 *
 */
export const scopesFiltered = win[NAV_SCOPES].scopesFiltered;

/**
 *
 */
export const hashFiltered = win[NAV_SCOPES].hashFiltered;

/**
 *
 */
export const searchFiltered = win[NAV_SCOPES].searchFiltered;

/**
 *
 */
export const pathFiltered = win[NAV_SCOPES].pathFiltered;
